import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import UserTrackRequest from '../../../RunPay/Admin/IServices/Models/Map/UserTrackRequest';
import TrackStatisticRequest from '../../../RunPay/Admin/IServices/Models/Map/TrackStatisticRequest';
import GetMapRequest from '../../../RunPay/Admin/IServices/Models/Map/GetMapRequest';
import SearchUserMapRequest from '../../../RunPay/Admin/IServices/Models/Map/SearchUserMapRequest';
import ChangePosPositionRequest from '../../../RunPay/Admin/IServices/Models/Map/ChangePosPositionRequest';
import SearchPosesRequest from '../../../RunPay/Admin/IServices/Models/Map/SearchPosesRequest';
import GetDatesWithTrackRequest from '../../../RunPay/Admin/IServices/Models/Map/GetDatesWithTrackRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import MapPositionItemResponse from '../../../RunPay/Admin/IServices/Models/Map/MapPositionItemResponse';
import TrackStatisticItemResponse from '../../../RunPay/Admin/IServices/Models/Map/TrackStatisticItemResponse';
import MapItemResponse from '../../../RunPay/Admin/IServices/Models/Map/MapItemResponse';
import MapDetailsItemResponse from '../../../RunPay/Admin/IServices/Models/Map/MapDetailsItemResponse';
import MapEmployeeItemResponse from '../../../RunPay/Admin/IServices/Models/Map/MapEmployeeItemResponse';
import GetPosForAddToMap from '../../../RunPay/Admin/IServices/Models/Map/GetPosForAddToMap';

export default class MapService {
	webApiService: WebApiService;
	GetUserTrackDataEvent = new Events<WsResponseModel<Array<MapPositionItemResponse>>>();
	GetTrackStatisticEvent = new Events<WsResponseModel<Array<TrackStatisticItemResponse>>>();
	GetPosMarkersEvent = new Events<WsResponseModel<Array<MapItemResponse>>>();
	GetPosMarkerDetailsEvent = new Events<WsResponseModel<MapDetailsItemResponse>>();
	GetUsersForMapEvent = new Events<WsResponseModel<Array<MapEmployeeItemResponse>>>();
	SetPosMapPositionEvent = new Events<WsResponseModel<Boolean>>();
	GetPosWithoutPositionEvent = new Events<WsResponseModel<Array<GetPosForAddToMap>>>();
	GetDatesWithTrackInfoEvent = new Events<WsResponseModel<Array<Date>>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('MapService', 'GetUserTrackData', (res: WsResponseModel<Array<MapPositionItemResponse>>) => {
			self.GetUserTrackDataEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetTrackStatistic', (res: WsResponseModel<Array<TrackStatisticItemResponse>>) => {
			self.GetTrackStatisticEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetPosMarkers', (res: WsResponseModel<Array<MapItemResponse>>) => {
			self.GetPosMarkersEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetPosMarkerDetails', (res: WsResponseModel<MapDetailsItemResponse>) => {
			self.GetPosMarkerDetailsEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetUsersForMap', (res: WsResponseModel<Array<MapEmployeeItemResponse>>) => {
			self.GetUsersForMapEvent.trigger(res);
		});
		webApiService.on('MapService', 'SetPosMapPosition', (res: WsResponseModel<Boolean>) => {
			self.SetPosMapPositionEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetPosWithoutPosition', (res: WsResponseModel<Array<GetPosForAddToMap>>) => {
			self.GetPosWithoutPositionEvent.trigger(res);
		});
		webApiService.on('MapService', 'GetDatesWithTrackInfo', (res: WsResponseModel<Array<Date>>) => {
			self.GetDatesWithTrackInfoEvent.trigger(res);
		});
	}
	GetUserTrackData(request: UserTrackRequest = null) { 	
        this.webApiService.send('MapService', 'GetUserTrackData' , request);
    }
	GetTrackStatistic(request: TrackStatisticRequest = null) { 	
        this.webApiService.send('MapService', 'GetTrackStatistic' , request);
    }
	GetPosMarkers(request: GetMapRequest = null) { 	
        this.webApiService.send('MapService', 'GetPosMarkers' , request);
    }
	GetPosMarkerDetails(posId: number = 0) { 	
        this.webApiService.send('MapService', 'GetPosMarkerDetails' , posId);
    }
	GetUsersForMap(request: SearchUserMapRequest = null) { 	
        this.webApiService.send('MapService', 'GetUsersForMap' , request);
    }
	SetPosMapPosition(request: ChangePosPositionRequest = null) { 	
        this.webApiService.send('MapService', 'SetPosMapPosition' , request);
    }
	GetPosWithoutPosition(request: SearchPosesRequest = null) { 	
        this.webApiService.send('MapService', 'GetPosWithoutPosition' , request);
    }
	GetDatesWithTrackInfo(request: GetDatesWithTrackRequest = null) { 	
        this.webApiService.send('MapService', 'GetDatesWithTrackInfo' , request);
    }
	 // async methods
	async getUserTrackDataAsync(request: UserTrackRequest = null): Promise<Array<MapPositionItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetUserTrackData.bind(this), this.GetUserTrackDataEvent)(request);
	}
	async getTrackStatisticAsync(request: TrackStatisticRequest = null): Promise<Array<TrackStatisticItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetTrackStatistic.bind(this), this.GetTrackStatisticEvent)(request);
	}
	async getPosMarkersAsync(request: GetMapRequest = null): Promise<Array<MapItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPosMarkers.bind(this), this.GetPosMarkersEvent)(request);
	}
	async getPosMarkerDetailsAsync(posId: number = 0): Promise<MapDetailsItemResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPosMarkerDetails.bind(this), this.GetPosMarkerDetailsEvent)(posId);
	}
	async getUsersForMapAsync(request: SearchUserMapRequest = null): Promise<Array<MapEmployeeItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetUsersForMap.bind(this), this.GetUsersForMapEvent)(request);
	}
	async setPosMapPositionAsync(request: ChangePosPositionRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.SetPosMapPosition.bind(this), this.SetPosMapPositionEvent)(request);
	}
	async getPosWithoutPositionAsync(request: SearchPosesRequest = null): Promise<Array<GetPosForAddToMap>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetPosWithoutPosition.bind(this), this.GetPosWithoutPositionEvent)(request);
	}
	async getDatesWithTrackInfoAsync(request: GetDatesWithTrackRequest = null): Promise<Array<Date>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDatesWithTrackInfo.bind(this), this.GetDatesWithTrackInfoEvent)(request);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/MapService.ts